import type { ISortOrder } from "@/types/centra";
import type { FormattedFilters } from "@/types/filters";

import UI from "./UI";

interface FilterBarProps {
  sortOrder: ISortOrder;
  filters: FormattedFilters | undefined;
  productCount: number;
  clearFilters: () => void;
}

const FilterBar = ({
  sortOrder,
  filters,
  productCount,
  clearFilters,
}: FilterBarProps) => {
  return (
    <UI
      sortOrder={sortOrder}
      filters={filters}
      productCount={productCount}
      clearFilters={clearFilters}
    />
  );
};

export default FilterBar;
